<template>
  <div class="nd-send-code" :class="isDisabled" data-sensors-click>
    <span v-if="status" class="time">{{ timeFormat }}</span>
    <span v-else @click="clickHandler">
      <slot>{{ hasSend ? '再次获取' : '获取验证码' }}</slot>
    </span>
  </div>
</template>

<script>
import { repeat } from '../../assets/utils'
export default {
  name: 'nd-send-code',

  props: {
    sendCode: {
      type: Function,
      default: () => {
        return new Promise(resolve => resolve(true))
      }
    },
    duration: {
      type: Number,
      default: 120
    },
    disabled: {
      type: Boolean,
      default: false
    },
    fmt: {
      type: String,
      default: 'm秒'
    }
  },

  data () {
    return {
      status: false, // false 计时器没开始
      time: this.duration, // 计时器时间 s
      timer: null, // 计时器
      hasSend: false
    }
  },

  computed: {
    isDisabled () {
      return (this.status || this.disabled) ? 'disabled' : 'un-disabled'
    },

    timeFormat () {
      new RegExp('(m+)').test(this.fmt)
      let time = String(this.time)
      if (RegExp.$1.length > 1) {
        time = (repeat('0', RegExp.$1.length) + time).substr(time.length)
      }

      return this.fmt.replace(/m+/, time)
    }
  },

  methods: {
    // 发送验证码，成功后开始计时器
    async clickHandler () {
      if (!this.status && !this.disabled) {
        const result = await this.sendCode().catch(err => this.$message(err))
        if (result) {
          this.clock()
          this.hasSend = true
        }
      }
    },
            
    // 计时器
    clock () {
      this.status = true
      this.timer = setInterval(() => {
        this.time--
        if (this.time <= 0) {
          this.status = false
          this.time = this.duration
          clearInterval(this.timer)
        }
      }, 1000)
    },

    clear () {
      this.status = false
      this.time = this.duration
      this.hasSend = false
      clearInterval(this.timer)
    }
  },

  destroyed () {
    this.clear()
  }
}
</script>

<style scoped lang="less">
@import "../../assets/less/mixin.less";

    .nd-send-code {
        height: 42px;
        line-height: 42px;
        text-align: center;

        &.disabled {
            color: @fc4;
            background-color: #FAFAFA;
        }

        &.un-disabled {
            color: #994B24;
            background-color: #FDF5DF;
        }

        span {
            line-height: 42px;
            font-size: 22px;
            white-space: nowrap;
        }
    }
</style>
